<template>
    <v-card color="#ddd" max-width="340" height="100%" flat tile outlined class="mx-auto pa-30 pa-lg-40">
        <h3 class="tit tit--sm text-center pb-24">이사회</h3>
        <v-row class="row--xxs">
            <v-col v-for="(item, index) in items" :key="index" cols="12">
                <p class="page-text page-text--lg line-height-1">
                    <v-row align="center" class="row--xxs">
                        <v-col cols="auto">
                            <div class="role">
                                <span v-for="(p, index) in item.role" :key="index">
                                    {{ p }}
                                </span>
                            </div>
                        </v-col>
                        <v-spacer />
                        <v-col cols="auto">
                            {{ item.name }}
                        </v-col>
                    </v-row>
                </p>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    role: ["대표", "이사"],
                    name: "이❋화",
                },
                {
                    role: "이사",
                    name: "공❋길",
                },
                {
                    role: "이사",
                    name: "손❋희",
                },
                {
                    role: "이사",
                    name: "오❋호",
                },
                {
                    role: "이사",
                    name: "최❋규",
                },
                {
                    role: "이사",
                    name: "윤❋원",
                },
                {
                    role: ["외부", "이사"],
                    name: "원❋숙",
                },
                {
                    role: ["외부", "이사"],
                    name: "이❋수",
                },
                {
                    role: "감사",
                    name: "이❋준",
                },
                {
                    role: ["외부", "감사"],
                    name: "최❋석",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.role {
    width: 58px;
    display: flex;
    justify-content: space-between;
    @media (min-width: 768px) {
        width: 65px;
    }
}
</style>
